// extracted by mini-css-extract-plugin
export var animatedLiftsContainer = "animatedLifts-module--animatedLiftsContainer--olria";
export var lottieLeft = "animatedLifts-module--lottieLeft--h1yto";
export var lottieRight = "animatedLifts-module--lottieRight--jz8Kq";